// src/Components/PublicRoute.js
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const PublicRoute = ({ redirectPath = "/user/home" }) => {
  const token = Cookies.get("token");
  
  if (token) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;